import React, { memo, useCallback, useMemo } from 'react'

import { FiltersSidebar } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

import { FILTER_NAME } from 'Pods/SearchPage/Shared/Tracking/constants'
import { useTrackFilterSelect } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { addLicense, removeLicense, setAiUsageAllowed } from 'Pods/SearchPage/Store/actions/licenses'
import { LICENSE_TYPE } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

import { getLicenseFiltersConfig, getAiUsageFiltersConfig } from './constants'

const stripLabels = groups => groups.map(group => ({ ...group, label: '' }))

function LicenseContent({ hideGroupLabels = false }) {
  const translate = useTranslate()

  const licenses = useSearchPageStore(state => state.licenses ?? [LICENSE_TYPE.ALL])
  const aiUsageAllowed = useSearchPageStore(state => state.aiUsageAllowed ?? false)
  const trackFilterSelect = useTrackFilterSelect()

  const handleLicenseFilterChange = useCallback((_, value, isOn) => {
    if (isOn) {
      trackFilterSelect(FILTER_NAME.LICENSE, value)
      addLicense(value)
    } else {
      removeLicense(value)
    }
  }, [trackFilterSelect])

  const handleAiUsageFilterChange = useCallback((_, _value, isOn) => {
    if (isOn) {
      trackFilterSelect(FILTER_NAME.LICENSE, 'ai_usage_allowed')
    }
    setAiUsageAllowed(isOn)
  }, [trackFilterSelect])

  const licenseFiltersConfig = useMemo(() => {
    const config = getLicenseFiltersConfig(translate, aiUsageAllowed)
    return hideGroupLabels ? stripLabels(config) : config
  }, [aiUsageAllowed, hideGroupLabels, translate])

  const aiConfig = useMemo(() => {
    const config = getAiUsageFiltersConfig(translate)
    return hideGroupLabels ? stripLabels(config) : config
  }, [hideGroupLabels, translate])

  const selectedAiUsageFilter = useMemo(
    () => [aiUsageAllowed ? 'ai_usage_allowed' : 'no_ai_usage_allowed'],
    [aiUsageAllowed],
  )

  return (
    <>
      <FiltersSidebar
        isCollapsible={false}
        filters={licenseFiltersConfig}
        selectedFilters={licenses}
        onFiltersChange={handleLicenseFilterChange}
        isControlled
        useNewCheckboxes
        hideShowMore
        baseFormWrapperClassName="filter-wrapper__content"
      />
      <FiltersSidebar
        isCollapsible={false}
        filters={aiConfig}
        selectedFilters={selectedAiUsageFilter}
        onFiltersChange={handleAiUsageFilterChange}
        hideLastDivider
        isControlled
        hideShowMore
        useNewCheckboxes
        baseFormWrapperClassName="filter-wrapper__content"
      />
    </>
  )
}

LicenseContent.propTypes = {
  hideGroupLabels: bool,
}

export default memo(LicenseContent)
